<mat-form-field matNativeControl appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input #search matInput type="text" [(ngModel)]="value" placeholder="Search..." (keyup)="applyFilter($event)" />
    <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value = ''; clearFilter()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>